import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient as AngularHttpClient } from '@angular/common/http';
import { withLatestFrom, flatMap, switchMap } from 'rxjs/operators';
import { WorkflowConfigService } from '@ispm/workflow/services/workflow-config.service';
import { HttpClient } from '@ispm-client/modules/core/services/http-client';
import { RevisionContextHttpClient } from '@ispm-client/modules/core/services/revision-context-http-client';
import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';

/**
 * ResourceRestService for ISPM web server
 * replaces saved words exist as part of the respourceRest Map with the actual content
 */
@Injectable()
export class IspmRevisionContextHttpClient implements RevisionContextHttpClient {
  public http: AngularHttpClient;

  constructor(private httpClient: HttpClient, private isgHttp: HttpInterceptorService, private workflowConfigService: WorkflowConfigService) {
  }

  private buildUrl(url, params= { }) {
    return this.workflowConfigService.propertiesPopulate(params).pipe(
      flatMap((_params) => this.isgHttp.buildUrl(url, _params)),
      flatMap(_url => this.workflowConfigService.interpolateWithResourcesMap(_url))
    );
  }

  normalizeBody(body) {
    return this.workflowConfigService.propertiesPopulate(body);
  }

  public get<T = any>(url: string, params?: any, toggleLoader?: boolean, headers?: { [prop: string]: string }, options?: { [prop: string]: string }): Observable<T> {
    return this.buildUrl(url, params).switchMap((populatedUrl) => this.httpClient.get(populatedUrl, params, toggleLoader, headers, options));
  }

  public post<T = any>(url, body, toggleLoader?: boolean, headers?: { [prop: string]: string }, params?: { [prop: string]: string }, options?: { [prop: string]: any }): Observable<T> {
    return this.buildUrl(url, params).pipe(
      withLatestFrom(this.normalizeBody(body)),
      switchMap(([populatedUrl, populatedBody]) => this.httpClient.post(populatedUrl, populatedBody, toggleLoader, headers, options)));
  }

  public put<T = any>(url, body, toggleLoader?: boolean, headers?: { [prop: string]: string }, params?: { [prop: string]: string }, options?: { [prop: string]: string }): Observable<T> {
    return this.buildUrl(url, params).pipe(
      withLatestFrom(this.normalizeBody(body)),
      switchMap(([populatedUrl, populatedBody]) => this.httpClient.put(populatedUrl, populatedBody, toggleLoader, headers, params, options)));
  }

  public delete(url: string, params?: any, toggleLoader?: boolean, headers?: { [prop: string]: string }, options?: { [prop: string]: string }): any {
    return this.buildUrl(url, params).switchMap((populatedUrl) => this.httpClient.delete(populatedUrl, params, toggleLoader, headers, options));
  }

}
